import { Component, Input } from '@angular/core';
import { StudentCourseEqualizationStatus } from '../../models/StudentCourseEqualization';

@Component({
    selector: 'app-student-course-equalization-status',
    template: `
<span class="badge" *ngIf="value"
        [class.text-bg-primary]="value == 'Project'"
        [class.text-bg-success]="value == 'Approved'"
        [class.text-bg-dark]="value == 'Submitted'"
        [class.text-bg-secondary]="value == 'Draft'"
        [class.text-bg-warning]="value == 'ReturnedForAddition' || value == 'ReturnedForApproval'"
        [class.text-bg-info]="value == 'Registered'">
    {{'studentCourseEqualization_status' + value | translate}}
</span>
`
})
export class StudentCourseEqualizationStatusComponent {
    @Input() value: StudentCourseEqualizationStatus;
}
